"use strict";

angular.module("core")
.factory("ActionFactory", function($q, $rootScope, ModalService, FlashBag, common) {
    return (function(service) {
        var bulkActionParams = service.getBulkActionParams();
        var singleActionParams = service.getSingleActionParams();

        this.submitBulkAction = function(action, referenceId) {
            var params = {reference_id: referenceId};
            var selectedInstances = getSelected(action, bulkActionParams, params);
            return submit(action, bulkActionParams, selectedInstances, referenceId);
        };

        this.submitSingleAction = function(action, instanceId, referenceId) {
            var params = {id: instanceId, reference_id: referenceId};
            var selectedInstances = getSelected(action, singleActionParams, params);
            return submit(action, singleActionParams, selectedInstances, referenceId);
        };

        function getSelected(action, actions, params) {
            return actions[action].resource.query(params,
                function onSuccess(data) {
                },
                function onError(response) {
                    FlashBag.apiError(response);
                }
            );
        }

        function submit(action, actions, selectedInstances, referenceId) {
            var deferred = $q.defer();

            selectedInstances.$promise.then(function(data) {
                openModal(action, actions, data)
                .then(function onSuccess(modalFormData) {
                    if (!modalFormData) {
                        return;
                    }

                    var params = {reference_id: referenceId};
                    var formInstances = modalFormData.selectedInstances;

                    if (action === "send_notification") {
                        params = angular.extend(params, modalFormData.notificationMessage);
                    }

                    if (action === "credit_limit_block" || action === "credit_limit_warning") {
                        params["credit_limits"] = modalFormData.credit_limits;
                    }
                    if (action === "overdue_block" || action === "overdue_warning") {
                        params["net_payment_days"] = modalFormData.net_payment_days;
                    }

                    if (action === "update_allowed_payment_methods") {
                        params["allowed_payment_methods"] = modalFormData.allowed_payment_methods;
                    }

                    if (action === "update_allowed_pre_authorized_payment_methods") {
                        params["allowed_pre_authorized_payment_methods"] = modalFormData.allowed_pre_authorized_payment_methods;
                    }

                    if (action === "update_pre_authorized_payment_agreement_type") {
                        params["pre_authorized_payment_agreement_type"] = modalFormData.pre_authorized_payment_agreement_type;
                    }

                    if (formInstances.length === 1) {
                        params["id"] = formInstances[0].id;
                    }
                    if (action === "disable") {
                        params["enabled"] = false;
                    }
                    if (action === "enable") {
                        params["enabled"] = true;
                    }
                    if (action === "send_reminder") {
                        var email_overrides = {};
                        angular.forEach(formInstances, function(value, key) {
                            email_overrides[value.id.toString()] = value.email;
                        });
                        params["email_overrides"] = email_overrides;
                    }
                    if (action === "send_financial_reminder") {
                        var email_overrides = {};
                        angular.forEach(formInstances, function(value, key) {
                            email_overrides[value.id.toString()] = value.emails;
                        });
                        params["email_overrides"] = email_overrides;
                    }
                    if (action === "emailOrder" || action === "emailInvoice") {
                        params["email"] = modalFormData.email;
                    }

                    actions[action].resource.save(params)
                    .$promise.then(function onSuccess(response) {
                        var file_data;

                        if (action === "exportOrder") {
                            file_data = response.file_data;
                            if (file_data) {
                                common.downloadExcelFile(file_data, response.file_name);
                            }
                            else {
                                FlashBag.preformattedError(gettextCatalog.getString("There was an error while generating the file. Please try again."));
                            }
                        }

                        if (action === "printOrder" || action === "printInvoice") {
                            file_data = response.file_data;
                            if (file_data) {
                                common.downloadFile(file_data, response.file_name, {type: "application/pdf;charset=utf-8;"});
                            }
                            else {
                                FlashBag.preformattedError(gettextCatalog.getString("There was an error while generating the file. Please try again."));
                            }
                        }

                        if (action === "createInvoice") {
                            $rootScope.UpdateCurrentNumbers();
                        }

                        var successMessage = actions[action].successMessage;
                        if (successMessage) {
                            FlashBag.success(successMessage);
                        }
                        deferred.resolve(response);
                    },
                    function onError(response) {
                        FlashBag.apiError(response);
                        deferred.reject(response);
                    });
                });
            });

            return deferred.promise;
        }

        function openModal(action, actions, instances) {
            var controller = actions[action].controller || "BulkActionConfirmationController";
            var controllerAs = actions[action].controllerAs || "bulkActionConfirmationCtrl";

            return ModalService.showModal({
                templateUrl: require("../../" + actions[action].modalTemplatePackage + "/app-core/action-modal/" + actions[action].modalTemplatePrefix + "-confirmation.modal.html"),
                controller: controller,
                controllerAs: controllerAs,
                inputs: {
                    $attrs: {
                        selectedInstances: instances,
                        text: actions[action].text,
                        message: actions[action].message,
                        params: actions[action].params
                    }
                }
            }).then(function(modal) {
                modal.element.modal();
                modal.element.on("hidden.bs.modal", function(e) {
                    modal.element.remove();
                });
                return modal.close;
            });
        }

    });
});



//////////////////
// WEBPACK FOOTER
// ./core/action/action.factory.js
// module id = 462
// module chunks = 0